import React, { useMemo, useState } from "react";
import ExportExcel from "./ExportExcel";
import Table from 'react-bootstrap/Table';
import 'bootstrap/dist/css/bootstrap.min.css';
import PaginationByApi from "../Pagination/paginationByApi";
import Pagination from "../Pagination/pagination";
import ItemSelect from "../SelectItemsPerPage/SelectItemsPerPage";

export const DataTable = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * pageSize;
        const lastPageIndex = firstPageIndex + pageSize;
        if (props.PerPageApiData && props.paginationItems) {
            return props?.data
        } else {
            return props?.data?.slice(firstPageIndex, lastPageIndex);
        }
    }, [currentPage, props?.data, pageSize]);


    const getCellHeaders = () => {
        let cols = props.cellHeaders.map((item, id) => {
            if (typeof item === "object" && item.type === "button") {
                const start = (currentPage - 1) * pageSize;
                const end = start + pageSize;
                const pageData = (props.data.slice(start, end));
            return (
                <th key={id}>
                <button
                    className="select-all-btn"
                    type="button"
                    onClick={() => item.onClick(pageData)}
                >
                    {item.label}
                    <br/>
                    <input type='checkbox' checked={props.isCurrentPageSelected} style={{height: "20px", width: "20px"}}/>
                </button>
                </th>
            );
            }
            return (
                <th key={id}>{item}</th>
            )
        })
        return (<tr>
            {props.addSerialNo && <th>S.NO.</th>}
            {cols}
        </tr>)
    }
    const getBody = () => {
        const { customButtonName } = props;
        return currentTableData && currentTableData?.map((item, index) => {
            return (
                <tr key={index}>
                    {props.addSerialNo &&
                        <td>{index + 1}</td>}
                    {
                        props.keys.map((key, ind) => {
                            if (ind === props.clickColumnIndex) {
                                return (
                                    <td key={ind} className={`row link ${props.rowCustomCss}`}
                                        onClick={() => props.onRowClick(item)}>{props.convertValueToString ? item[key]?.toString() : item[key]}</td>
                                )
                            } else if (key === "customButtons") {
                                return <td key={ind}>
                                    <button className="custom-button"
                                        onClick={() => props.onCustomButtonClick(item)}>{customButtonName || "Edit"}</button>
                                </td>
                            }
                            else if (key === "FreezecustomButtons") {
                                return <td key={ind}>
                                    <div  className="dataTable-btn"><button className="tpaBtn" 
                                        onClick={() => props.onCustomButtonClick(item)}><i class="fa fa-edit" ></i> {customButtonName || ""} </button>
                                    <button className="tpaBtn"
                                        onClick={() => props.onCustomDeletButtonClick(item)}><i class="fa fa-trash" ></i> </button>    
                                        </div>
                                </td>
                            } else if (props.converTdToComponent == key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.secondconverTdToComponent == key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.thirdconverTdToComponent == key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (key === 'paymentMethod') {
                                if (item.paymentMethod?.length) {
                                    let payMethod = item.paymentMethod.replace(/]/g, '')
                                    payMethod = payMethod.replace(/\[/g, '')
                                    return (<td key={ind}>
                                        {payMethod}
                                    </td>)
                                } else {
                                    return (<td key={ind}>
                                        {item.paymentMethod}
                                    </td>)
                                }
                            } else if (props.fourthconverTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.fifthconvertTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.sixthconvertTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.seventhconvertTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.AAconvertTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if(props.upfrontconvertTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            }else if(props.parallelconvertTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.idpconvertTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.easePointingconvertTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else {
                                return (
                                    <td key={ind}>{props.convertValueToString ? item[key]?.toString() : item[key]}</td>
                                )
                            }

                        })
                    }
                </tr>
            )
        })
    }


    return (<>


        <div className="proposal-table">
            {props.showExcelDownload ? <div className="excel-download">
                <ExportExcel
                    cellHeaders={props.cellHeaders}
                    data={props.data}
                    keys={props.keys}
                    fileName={props.fileName}
                    addSerialNo={props.addSerialNo}
                />
            </div> : ''}

            {!props.PerPageApiData && props.paginationItems ? (
                <div className={`proposal-table__controls ${props.tableToolbarClassName || ""}`}>
                    <ItemSelect itemsPerPage={pageSize} setItemsPerPage={setPageSize} />
                    {props.tableToolbarExtra}
                </div>
            ) : ''}
            <Table responsive striped bordered={true} hover variant="light">
                <thead>
                    {getCellHeaders()}
                </thead>
                <tbody>
                    {getBody()}
                </tbody>
            </Table>
            {props.PerPageApiData && props.paginationItems ? <PaginationByApi
                itemsCount={props.paginationItems.totalItems}
                itemsPerPage={props.itemsPerPage}
                currentPage={props.currentPage + 1}
                setCurrentPage={props.setCurrentPage}
                alwaysShown={props.alwaysShown}
            /> : ''}
            {!props.PerPageApiData && props.paginationItems ? <Pagination
                className="pagination-bar"
                currentPage={currentPage}
                totalCount={props.data.length}
                pageSize={pageSize}
                onPageChange={page => setCurrentPage(page)}
            /> : ''}
        </div>
    </>)
}

export default DataTable;
